import React, { Component, Fragment, useLayoutEffect, useState } from "react";
import { createRef } from "react";
import Draggable from "react-draggable";
// import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../stores/actionsList";
import { getBoundingClientRect } from "../../utils/functions";
import Tower from "../Tower";
import { CalcResize } from "./CalcReisze";
import WindowContent from "./WindowContent";
import WindowShots from "./WindowShots";
import { checkTranslation, translate } from "../../utils/useful";

class Window extends Component {
    state = {
        showBox: true,
        dragProps: {
            width: 800,
            height: 480,
            radius: 10,
            position: null,
            disabled: false,
            canMaximize: true,
            canClose: true,
            canMinimize: false,
        },
        appSize: {
            appWidth: window.innerWidth,
            appHeight: window.innerHeight
        },
        resizeArrows: [
            { direction: 'nw', style: { top: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px' } },
            { direction: 'ne', style: { top: this.props.lang == 'en' ? '-1px' : '1px', right: this.props.lang == 'en' ? '-1px' : '1px' } },
            { direction: 'sw', style: { bottom: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px' } },
            { direction: 'se', style: { bottom: this.props.lang == 'en' ? '-1px' : '1px', right: this.props.lang == 'en' ? '-1px' : '1px' } },
            { direction: 'top', style: {} },
            { direction: 'bottom', style: {} },
            { direction: 'left', style: {} },
            { direction: 'right', style: { right: this.props.lang == 'en' ? '0' : '0' } },
        ],
        isResizing: false,
        isDesktop: true,
        isMobile: false,
        disableDrag: false
    };

    resizableRef = createRef();



    componentDidMount() {
        // // console.log('kkkkkkkkk',this.props.lastSelected);
        if (this.props.user.windows[this.props.id]) {
            // // console.log('kkkkkkkkk');
            // console.log('this.props.user.windows',this.props.user.windows)
            let newWindows = JSON.parse(JSON.stringify(this.props.user.windows))
            this.setState({
                dragProps: {
                    width: newWindows[this.props.id].width,
                    height: newWindows[this.props.id].height,
                    radius: 10,
                    position: newWindows[this.props.id].defaultPosition,
                    disabled: newWindows[this.props.id].disabled ?? false,
                    canMaximize: newWindows[this.props.id].canMaximize ?? true,
                    canClose: newWindows[this.props.id].canClose ?? true,
                    canMinimize: newWindows[this.props.id].canMinimize ?? false,
                }
            }, () => {
                // console.log('draaaggggggggggggggggg', this.state.dragProps);
                this.mouseup()
            })
        }
        window.addEventListener("resize", () => this.resizeComponent());
        // this.setState({resizableRect: this.resizableRef.current.getBoundingClientRect()})

        // // console.log('heredragProps',this.state.dragProps)
        // // console.log('hereww',this.props.width)
        // // console.log('herehh',this.props.height)
        // // console.log('herewin',this.props.windows)
        this.resizeComponent()


        // let dragProps = this.state.dragProps
        // dragProps.width = this.props.width
        // dragProps.height = this.props.height
        // 
        // 
        // this.setState({ dragProps })
        // let bound = this.resizableRef.current.getBoundingClientRect();

    }

    componentWillUnmount() {
        //    this.props.takeScreenshot(
        //        this.props.id,
        //        this.windowContentRef,
        //        "Mobile"
        //    );
        window.removeEventListener("resize", () => this.resizeComponent());
    }



    mouseDown = (e, direction) => {
        // console.log('hereeeeeedow');
        // e.stopPropagation()
        // e.preventDefault()
        const rect = this.resizableRef.current.getBoundingClientRect();


        e.persist()
        this.setState(
            (prev) => {
                return {
                    dragProps: {
                        ...prev.dragProps,
                        disabled: true
                    }
                };
            },
            () => {
                // 
                this.setState({ direction }, () => {
                    this.setState(
                        {
                            prevClient: {
                                prevClientX: e?.clientX,
                                prevClientY: e?.clientY
                            },
                            initialPosition: {
                                x: rect.left,
                                y: rect.top,
                                width: rect.width,
                                height: rect.height,
                                top: rect.top,
                                left: rect.left,
                                right: rect.right
                            }
                        },
                        () => {
                            // window.addEventListener("mousemove", (ev) => {
                            //     this.mouseMove(ev, direction);
                            // });
                            // 
                            // // console.log('pppoooooossssss', this.state.initialPosition);

                            window.addEventListener(
                                "mousemove",
                                this.mouseMove
                            );

                            window.addEventListener("mouseup", this.mouseup);
                        }
                    );
                });
            }
        );
    };
    mouseup = (e, direction) => {
        // console.log('hereeeeeedouuppppw');

        // e.stopPropagation();
        // e.preventDefault();
        const rect = this.resizableRef.current.getBoundingClientRect();

        let diffrenece;
        if (this.props.language == 'fa') {
            diffrenece = -(window.innerWidth - rect.right)

        } else {
            diffrenece = rect.left
        }
        // console.log('heqmovedef', diffrenece, rect);
        this.setState(
            (prev) => {
                // 
                // 
                return {
                    dragProps: {
                        ...prev.dragProps,
                        disabled: false,
                        position: { x: diffrenece, y: rect.y },
                        width: rect.width,
                        height: rect.height
                    }
                };
            }, () => {
                this.setState((prev) => {
                    // 
                    let windows = JSON.parse(JSON.stringify(this.props.user.windows))
                    windows[this.props.id].width = this.state.dragProps.width
                    windows[this.props.id].height = this.state.dragProps.height
                    windows[this.props.id].defaultPosition.x = this.state.dragProps.position.x
                    windows[this.props.id].defaultPosition.y = this.state.dragProps.position.y
                    // console.log('pppoooooossssss', windows[this.props.id]);
                    // console.log('pppoooooossssss', this.props.user.windows[this.props.id]);
                    this.props.actions.changeWindow(windows)

                    // // console.log('hereeeeeedouuppppw', this.state.dragProps);

                    return {
                        dragProps: {
                            ...prev.dragProps,
                            position: null
                        }
                    };
                })
            }
        );
        // 
        // window.removeEventListener("mousemove", () => {});
        // window.removeEventListener("mousemove", () => {});
        window.removeEventListener("mousemove", this.mouseMove);
        window.removeEventListener("mouseup", this.mouseup);
        // this.resizeComponent()

        // window.removeEventListener("mouseup", () => {});
    };
    mouseMove = (e) => {
        // console.log('heqmove', e);
        let windowRef = this.resizableRef.current
        e.preventDefault()
        e.stopPropagation()

        const { height, position, width } = CalcResize(
            this.props.language,
            this.state.direction,
            { ...this.state.initialPosition },
            this.state.prevClient,
            e,
        );
        // console.log('heqmove2whp', width, height, position);
        if (width > 400 && height > 400) {
            if (position || height || width) {

                windowRef.style.transform = `translate(${position.x}px, ${position.y}px)`
                // windowRef.style.transform = `translateY(${position.y}px)`
                windowRef.style.height = height + 'px'
                windowRef.style.width = width + 'px'
                // windowRef.style.background = 'red'
                // console.log('heqmove2', windowRef.style.transform);
            }

        }
    };

    fullScreen = (e) => {
        let windows = JSON.parse(JSON.stringify(this.props.user.windows))
        // console.log('fullllllllllll');
        e.stopPropagation()
        e.preventDefault()
        let bound = this.resizableRef.current.getBoundingClientRect();
        this.setState({ prevLeft: bound.left, prevRight: bound.right, prevTop: bound.top, prevWidth: this.state.dragProps.width, prevHeight: this.state.dragProps.height }, () => {
            this.setState((prev) => ({
                ...prev,
                dragProps: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    radius: 0,
                    position: { x: 0, y: 0 },
                    disabled: true,
                    canMaximize: false,
                    canMinimize: windows[this.props.id].canMinimize,
                    canClose: windows[this.props.id].canClose
                }
            }));
        });
        setTimeout(() => {

            windows[this.props.id].befforeFullSc = JSON.parse(JSON.stringify(windows[this.props.id]))
            windows[this.props.id].width = this.state.dragProps.width
            windows[this.props.id].height = this.state.dragProps.height
            windows[this.props.id].disabled = this.state.dragProps.disabled
            windows[this.props.id].canMaximize = this.state.dragProps.canMaximize
            // windows[this.props.id].canMinimize = this.state.dragProps.canMinimize
            // windows[this.props.id].canClose = this.state.dragProps.canClose
            windows[this.props.id].defaultPosition.x = this.state.dragProps.position.x
            windows[this.props.id].defaultPosition.y = this.state.dragProps.position.y
            // console.log('pppoooooossssss', windows[this.props.id]);
            // // console.log('pppoooooossssss', this.props.user.windows[this.props.id]);
            this.props.actions.changeWindow(windows)
        }, 300);



    }
    exitFullScreen = (e) => {
        let windows = JSON.parse(JSON.stringify(this.props.user.windows))
        e.stopPropagation()
        e.preventDefault()
        // console.log('windddoooooooooooooooo', windows);
        let bound = this.resizableRef.current.getBoundingClientRect();
        this.setState(
            (prev) => ({
                ...prev,
                dragProps: {
                    width: windows[this.props.id].befforeFullSc?.width,
                    height: windows[this.props.id].befforeFullSc?.height,
                    radius: 10,
                    position: { x: windows[this.props.id].befforeFullSc?.defaultPosition?.x, y: windows[this.props.id].befforeFullSc?.defaultPosition?.y },
                    disabled: false,
                    canMaximize: true,
                    canMinimize: windows[this.props.id].canMinimize ?? false,
                    canClose: windows[this.props.id].canClose ?? false
                }
            }),
            () => {
                // console.log('hereeeeeee');
                this.setState((prev) => ({
                    ...prev,
                    dragProps: {
                        ...prev.dragProps,
                        position: { x: windows[this.props.id].befforeFullSc?.defaultPosition?.x, y: windows[this.props.id].befforeFullSc?.defaultPosition?.y },
                    }
                }), () => {


                });
                setTimeout(() => {

                    windows[this.props.id] = JSON.parse(JSON.stringify(windows[this.props.id].befforeFullSc))
                    // console.log('wiiinnnnnnnn', windows);
                    this.props.actions.changeWindow(windows)
                }, 300);
            }
        );
    }




    componentDidUpdate(prevProps, prevState) {
        if(this.props.language != prevProps.language){
            this.resizeComponent()
        }


        let bound =
            this.resizableRef.current &&
            this.resizableRef.current.getBoundingClientRect();
        let width = this.state.appSize.appWidth;
        let prevWidth = prevState.appSize.appWidth;
        let height = this.state.appSize.appHeight;
        let prevHeight = prevState.appSize.appHeight;
        let horidiff = prevWidth - width;
        let verticDiff = prevHeight - height;

    }
    resizeComponent() {
        // return true
        // console.log('this.state.dragProps11111');
        let newWindow = JSON.parse(JSON.stringify(this.props.user.windows))
        // // console.log('here',newWindow);
        // if (this.resizableRef) {
        //     let bound = this.resizableRef.current.getBoundingClientRect();
        if (this.state.dragProps.canMinimize) {
            // console.log('here1');
            this.setState((prev) => ({
                dragProps: {
                    ...prev.dragProps,
                    width: newWindow[this.props.id].width,
                    height: newWindow[this.props.id].height
                }
            }));
        }
        // return true

        // 
        this.setState({
            appSize: {
                appWidth: window.innerWidth,
                appHeight: window.innerHeight
            }
        }, () => {
            // // console.log('heredraggggggg',this.state.dragProps, this.props.user.windows);
        });
        // return
        // // console.log('this.state.dragProps',window.innerWidth);
        if (window.innerWidth < 520) {
            // // console.log('here2');
            // 

            this.setState(prev => {
                return {
                    ...prev,
                    isDesktop: false,
                    isMobile: true,
                    dragProps: {
                        ...prev.dragProps,
                        width: window.innerWidth,
                        height: window.innerHeight,
                        position: {
                            x: 0,
                            y: 0
                        },
                        radius: 0
                    }
                }
            }, () => {

                this.props.takeScreenshot(this.props.id, this.windowContentRef, "Mobile")
            })
        } else {
            if (window.innerWidth > 520) {
                if (this.props.language == 'en') {
                    if (newWindow[this.props.id].defaultPosition.x - 200 > window.innerWidth || newWindow[this.props.id].defaultPosition.y + 100 > window.innerHeight|| newWindow[this.props.id].defaultPosition.x<0 ) {
                        let defaultPosition = {
                            x: Math.floor(Math.random() * ((window.innerWidth / 4))),
                            y: Math.floor(Math.random() * (window.innerHeight / 4)),
                        };
                        let width = (window.innerWidth / 3) * 2
                        let height = (window.innerHeight / 3) * 2
                        this.setState(prev => {
                            return {
                                ...prev,
                                isDesktop: true,
                                isMobile: false,
                                dragProps: {
                                    ...prev.dragProps,
                                    width: width,
                                    height: height,
                                    position: defaultPosition,
                                    radius: 10
                                }
                            }
                        }, () => {
                            // // console.log('here4',this.state.dragProps,this.props.width,this.props.height);
                            this.props.takeScreenshot(this.props.id, this.windowContentRef, "Desktop")
                            newWindow[this.props.id].width = width
                            newWindow[this.props.id].height = height
                            newWindow[this.props.id].defaultPosition = defaultPosition
                            this.props.actions.changeWindow(newWindow)
                            this.mouseup()

                        })
                    } else {

                        // console.log('here3', this.state.dragProps, this.props.user.windows);
                        // 

                        this.setState(prev => {
                            return {
                                ...prev,
                                isDesktop: true,
                                isMobile: false,
                                dragProps: {
                                    ...prev.dragProps,
                                    width: newWindow[this.props.id].width,
                                    height: newWindow[this.props.id].height,
                                    position: newWindow[this.props.id].defaultPosition,
                                    radius: 10
                                }
                            }
                        }, () => {
                            // // console.log('here4',this.state.dragProps,this.props.width,this.props.height);
                            this.props.takeScreenshot(this.props.id, this.windowContentRef, "Desktop")
                            this.mouseup()

                        })
                    }
                } else {

                    if (200 - newWindow[this.props.id].defaultPosition.x > window.innerWidth || newWindow[this.props.id].defaultPosition.y + 100 > window.innerHeight || newWindow[this.props.id].defaultPosition.x >0) {
                        let defaultPosition = {
                            x: - Math.floor(Math.random() * ((window.innerWidth / 4))),
                            y: Math.floor(Math.random() * (window.innerHeight / 4)),
                        };
                        let width = (window.innerWidth / 3) * 2
                        let height = (window.innerHeight / 3) * 2
                        this.setState(prev => {
                            return {
                                ...prev,
                                isDesktop: true,
                                isMobile: false,
                                dragProps: {
                                    ...prev.dragProps,
                                    width: width,
                                    height: height,
                                    position: defaultPosition,
                                    radius: 10
                                }
                            }
                        }, () => {
                            // // console.log('here4',this.state.dragProps,this.props.width,this.props.height);
                            this.props.takeScreenshot(this.props.id, this.windowContentRef, "Desktop")
                            newWindow[this.props.id].width = width
                            newWindow[this.props.id].height = height
                            newWindow[this.props.id].defaultPosition = defaultPosition
                            this.props.actions.changeWindow(newWindow)
                            this.mouseup()


                        })
                    } else {

                        // console.log('here3', this.state.dragProps, this.props.user.windows);
                        // 

                        this.setState(prev => {
                            return {
                                ...prev,
                                isDesktop: true,
                                isMobile: false,
                                dragProps: {
                                    ...prev.dragProps,
                                    width: newWindow[this.props.id].width,
                                    height: newWindow[this.props.id].height,
                                    position: newWindow[this.props.id].defaultPosition,
                                    radius: 10
                                }
                            }
                        }, () => {
                            // // console.log('here4',this.state.dragProps,this.props.width,this.props.height);
                            this.props.takeScreenshot(this.props.id, this.windowContentRef, "Desktop")
                            this.mouseup()
                        })
                    }
                }
            }

        }

        // }

    }


    changeWindow = (type, data) => {
        let id = this.props.id
        // console.log('fullpath1', type, data, id)
        this.props.changeWindow(id, type, data)
    }
    changeWindowButton = (button) => {
        // console.log('butoooooon', button, this.props.data.path);
        if (button.name == 'switchView' && this.props.data.path.includes('admin')) {
            let id = this.props.id
            let path = []
            path.push(this.props.data.path[0])
            path.push(this.props.data.path[1])
            this.props.changeWindow(id, 'applet', { type: 'applet', path: path })
        } else if (button.name == 'switchView' && !this.props.data.path.includes('admin')) {
            let id = this.props.id
            let path = []
            path.push(this.props.data.path[0])
            path.push(this.props.data.path[1])
            path.push('admin')
            this.props.changeWindow(id, 'applet', { type: 'applet', path: path })
        }
        // this.props.changeWindow(id, type, data)
    }

    setWindowInfo = (info) => {
        let id = this.props.id
        this.props.setWindowInfo(id, info)
    }

    setWindowButtons = (info) => {
        let id = this.props.id
        this.props.setWindowButtons(id, info)
    }
    minimizeWindow = (e) => {
        let id = this.props.id
        this.props.minimizeWindow(id)
        e.preventDefault()
        e.stopPropagation()
        this.setState({ disableDrag: true })
        setTimeout(() => {
            this.setState({ disableDrag: false })
        }, 400);
    }
    // draging = (e, windows) => {
    //     if (this.props.language == 'en') {

    //         // // console.log(windows)
    //         this.setState(
    //             (prev) => ({
    //                 ...prev,
    //                 dragProps: {
    //                     width: windows[this.props.id].width,
    //                     height: windows[this.props.id].height,
    //                     radius: 10,
    //                     position: { x: e.layerX - e.offsetX, y: e.layerY - e.offsetY },
    //                     disabled: windows[this.props.id].disabled ?? false,
    //                     canMaximize: windows[this.props.id].canMaximize ?? true,
    //                     canMinimize: windows[this.props.id].canMinimize ?? false,
    //                     canClose: windows[this.props.id].canClose ?? true
    //                 }
    //             }),
    //             () => {
    //                 // console.log('hereeeeeee',this.state.dragProps);
    //                 this.setState((prev) => ({
    //                     ...prev,
    //                     dragProps: {
    //                         ...prev.dragProps,
    //                         position: { x: e.layerX - e.offsetX, y: e.layerY - e.offsetY },
    //                     }
    //                 }), () => {


    //                 });
    //                 // setTimeout(() => {


    //                 console.log('this.state.dragProps11111', e.x - e.offsetX)
    //                 console.log('this.state.dragProps11111', e.y - e.offsetY)
    //                 windows[this.props.id].defaultPosition.x = e.layerX - e.offsetX
    //                 windows[this.props.id].defaultPosition.y = e.layerY - e.offsetY
    //                 // // console.log('this.state.dragProps', windows[this.props.id])
    //                 // // console.log('this.state.dragProps', windows[this.props.id].defaultPosition)
    //                 // // console.log('this.state.dragProps', windows)
    //                 this.props.actions.changeWindow(windows)

    //                 // }, 500);
    //             }
    //         );
    //     } else {
    //         this.setState(
    //             (prev) => ({
    //                 ...prev,
    //                 dragProps: {
    //                     width: windows[this.props.id].width,
    //                     height: windows[this.props.id].height,
    //                     radius: 10,
    //                     position: { x: e.layerX - e.offsetX, y: e.layerY - e.offsetY },
    //                     disabled: windows[this.props.id].disabled ?? false,
    //                     canMaximize: windows[this.props.id].canMaximize ?? true,
    //                     canMinimize: windows[this.props.id].canMinimize ?? false,
    //                     canClose: windows[this.props.id].canClose ?? true
    //                 }
    //             }),
    //             () => {
    //                 // console.log('hereeeeeee',this.state.dragProps);
    //                 this.setState((prev) => ({
    //                     ...prev,
    //                     dragProps: {
    //                         ...prev.dragProps,
    //                         position: { x: e.layerX - e.offsetX, y: e.y - e.offsetY },
    //                     }
    //                 }), () => {


    //                 });
    //                 // setTimeout(() => {
    //                 // return
    //                 // this.setState({dragging : false})
    //                 console.log('this.state.dragProps11111', e.x - e.offsetX)
    //                 console.log('this.state.dragProps11111', e.y - e.offsetY)
    //                 windows[this.props.id].defaultPosition.x = e.layerX - e.offsetX
    //                 windows[this.props.id].defaultPosition.y = e.layerY - e.offsetY
    //                 // // console.log('this.state.dragProps', windows[this.props.id])
    //                 // // console.log('this.state.dragProps', windows[this.props.id].defaultPosition)
    //                 // // console.log('this.state.dragProps', windows)
    //                 this.props.actions.changeWindow(windows)
    //                 // }, 500);
    //             }
    //         );
    //     }
    // }


    //     onDragEnd = (e) => {
    //         let windows = JSON.parse(JSON.stringify(this.props.user.windows))
    //         let event = {x:e.x,y:e.y,offsetX:e.offsetX,offsetY:e.offsetY}
    //         // console.log('hereeeeeee2222',event);
    //         // console.log('this.state.dragProps', e, this.state.disableDrag)
    //         // console.log('this.state.dragProps', this.state.dragProps.position)
    //         // this.setState({time : true} , ()=> {
    //             setTimeout(() => {

    //                 if (!this.state.disableDrag) {
    //                     this.draging(event, windows)
    //                 }
    //             }, 1);
    //         // });
    // // 
    //     }
    // onDragEnd = (e) => {
    //     let windowRef = this.resizableRef.current
    //     // return
    //     // e.stopPropagation()
    //     console.log('lanngggggg', e);
    //     if(this.state.dragging){

    //         if (e && this.state?.dragProps) {
    //             let windows = JSON.parse(JSON.stringify(this.props.user.windows))
    //             let event = { x: e.layerX, y: e.layerY, offsetX: e.offsetX, offsetY: e.offsetY }
    //             console.log('this.state.dragProps',this.state.dragProps);
    //             console.log('this.state.dragProps', event)
    //             // console.log('this.state.dragProps', Math.abs(this.state.dragProps.position.y - e.y),Math.abs(this.state.dragProps.position.x - e.x) )
    //             // console.log('this.state.dragProps', Math.abs( event.x - event.offsetX - this.state.dragProps.position.x ),Math.abs( event.y - event.offsetY -this.state.dragProps.position.y) )
    //             // this.setState({time : true} , ()=> {
    //                 // setTimeout(() => {
    //                     this.setState({dragging : false})

    //                     window.removeEventListener("mousemove", this.mouseMove);
    //                     window.removeEventListener("mouseup", this.mouseup);
    //                     // if ((Math.abs(this.state?.dragProps?.position?.x - e?.layerX) > 40 || Math.abs(this.state?.dragProps?.position?.layerY - e.y) > 130) && Math.abs(event?.x - event?.offsetX - this.state?.dragProps?.position?.x) > 1 && Math.abs(event?.y - event?.offsetY - this.state?.dragProps?.position?.y) > 1) {
    //                         this.draging(e, windows)

    //                     // }
    //                 }
    //         // }, 0.01);
    //         // });
    //         // 
    //     }else{
    //         this.props.changeIndex()
    //     }
    // }


    onDrag = (e) => {
        //    this.setState({dragging : true })
        // e.persist()

        // console.log('hereeeeeeq');
        e.preventDefault()
        // window.addEventListener(
        //     "mousemove",
        //     this.mouseMove
        // )
        window.addEventListener("mouseup", this.mouseup);

    }
    // dragmouseMove = (e) => {
    //     //    this.setState({dragging : true })
    //     e.preventDefault()
    //   e.stopPropagation()

    // }

    render() {
        const { dragProps, resizeArrows, appSize } = this.state;

        return (
            <Fragment>
                {/* {// console.log('windows --', this.props.windows[this.props.id])}
                {// console.log('windows --', !this.props.windows[this.props.id].minimized)}
                {// console.log('windows --', this.props.windows[this.props.id].minimized == false)} */}
                {/* {(!this.props.windows[this.props.id].minimized || this.props.windows[this.props.id].minimized == false) ? ( */}

                <Draggable
                    handle=".drag-handle"
                    bounds={{
                        left:
                            this.props.language == "en"
                                ? 0
                                : -appSize.appWidth + 50,
                        top: -dragProps.height + 50,
                        right:
                            this.props.language == "en"
                                ? appSize.appWidth - 50
                                : 0,
                        bottom: appSize.appHeight - 50
                    }}
                    onDrag={(e) => { this.onDrag(e) }}
                    // onStop={this.onDragEnd}
                    // onMouseMove={(e) => {this.dragmouseMove(e)}}
                    disabled={dragProps.disabled || this.state.disableDrag}
                    // onStart={(e)=>{ e.stopPropagation()}}
                    // onMouseDown={(e)=>{ e.stopPropagation()}}
                    position={this.state.dragProps.position}
                    defaultPosition={this.props.defaultPosition}
                // disabled={dragProps.disabled}

                // className="window"
                >

                    {/* {// console.log('this.props.windows[this.props.id]',this.props.windows[this.props.id])}
                    {// console.log('this.props.windows[this.props.id]wwwwww',this.props.windows)}
                    {// console.log('this.props.windows[this.props.id]iiiiiiii',this.props.id)} */}
                    <div
                        // onClick={this.props.changeIndex}
                        ref={this.resizableRef}
                        className="draggable-element d-flex "
                        style={{
                            width: dragProps.width,
                            height: this.state.isDesktop
                                ? dragProps.height
                                : dragProps.height - 35,
                            position: "absolute",
                            zIndex: this.props.zIndex,
                            borderRadius: dragProps.radius,
                            background: "white",
                            display: "flex",
                            flexFlow: this.state.isDesktop
                                ? "row"
                                : "column-reverse",
                            visibility: (!this.props.user.windows[this.props.id]?.minimized || this.props.user.windows[this.props.id]?.minimized == false)
                                ? ''
                                : 'hidden',
                            // visibility: !this.props.showWindowsShots ? 'visible' : 'hidden'
                        }}
                        onMouseDownCapture={this.props.changeIndex}
                    >


                        {this.state.isDesktop ? (
                            <div>
                                <div className="h-100">
                                    <div className="drag-handle window-side pt-2 h-100 flexcb flex-column"  >
                                        {/* {console.log('this.props.dragProps', this.state.dragProps)} */}
                                        <div className="d-flex flex-column">
                                            <div>
                                                {/* {dragProps.canClose && ( */}
                                                <div onClick={this.props.closeWindow} style={{ zIndex: 3 }} className="window-control-button">
                                                    <img src="/assets/icons/close.svg" width={20} />
                                                </div>
                                                {/* )} */}
                                            </div>
                                            <div>

                                                {dragProps.canMaximize ? (
                                                    <div onClick={(e) => this.fullScreen(e)} className="window-control-button">
                                                        <img src="/assets/icons/maximize.svg" width={15} />
                                                    </div>
                                                ) : (
                                                    <div onClick={(e) => this.exitFullScreen(e)} className="window-control-button" >
                                                        <img src="/assets/icons/maximize.svg" width={15} />
                                                    </div>
                                                )}
                                            </div>
                                            {/* {dragProps.canMinimize ? (
                                                <div onClick={() => this.minimize()} className="window-control-button" >
                                                    <img src="/assets/icons/maximize.svg" width={15} />
                                                </div>
                                            ) : null} */}
                                            <div>

                                                {dragProps.canMinimize && (
                                                    <div onClick={(e) => this.minimizeWindow(e)} className="window-control-button">
                                                        <img src="/assets/icons/minimize.svg" width={20} />
                                                    </div>
                                                )}
                                            </div>
                                            {/* {console.log(this.props.buttons)} */}
                                            {Array.isArray(this.props.buttons) && this.props.buttons.map((button, index) => {
                                                return (
                                                    <div key={index} onClick={() => this.changeWindowButton(button)} className="window-control-button">
                                                        <img src={button.icon} width={20} />
                                                    </div>
                                                )
                                            })}


                                        </div>






                                        <div className="window-type flexcc pb-3" style={{ height: 'calc(100% - 130px)', justifyContent: 'end' }}>


                                            <p className="text-small color-gray-1 text-semibold my-2 rotate-180" style={{ whiteSpace: 'nowrap', writingMode: "vertical-rl", textOrientation: 'sideways-right', overflow: 'hidden', textOverflow: 'ellipsis' }}>{translate(this.props.info?.title)}
                                            </p>
                                            {this.props.info?.icon && (
                                                <div className="px-2 ">
                                                    <img src={this.props.info?.icon} height={26} width={26} style={{ borderRadius: 20, objectFit: 'cover' }} />
                                                </div>
                                            )}

                                        </div>

                                    </div>


                                </div>
                            </div>
                        ) :
                            (<div></div>)
                            // <div className="window-bottombar" >{this.props.type}</div>
                        }
                        <div ref={el => this.windowContentRef = el} className=" h-100" style={{ width: this.state.isDesktop ? 'calc(100% - 50px)' : '100%', flex: 1, position: 'relative' }}>
                            {/* {// console.log('useerrwinnnn', this.props.user.windows)} */}
                            {/* <div ref={el => this.windowContentRef = el} className="h-100" style={{ flex: 1, overflow: 'hidden', position: 'relative' }}> */}
                            <WindowContent mainColor={this.props.mainColor} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} setWindowButtons={this.setWindowButtons} type={this.props.type} lastSelected={this.props.lastSelected} data={this.props.data} width={dragProps.width} height={dragProps.height} closeWindow={this.props.closeWindow} changeWindow={this.changeWindow} setWindowInfo={this.setWindowInfo} addNewWindow={this.props.addNewWindow} windowId={this.props.id} language={this.props.language} />
                        </div>

                        {/* <div
                            ref={(el) => (this.windowContentRef = el)}
                            className="h-100"
                            style={{
                                flex: 1,
                                overflow: "hidden",
                                position: "relative"
                            }}
                        >
                            <WindowContent
                                type={this.props.type}
                                data={this.props.data}
                                width={dragProps.width}
                                height={dragProps.height}
                                closeWindow={this.props.closeWindow}
                                changeWindow={this.changeWindow}
                                windowId={this.props.id}
                            />
                        </div> */}

                        {resizeArrows.map((arr, index) => {
                            const { direction, style } = arr;
                            return (
                                <div
                                    draggable={false}
                                    key={index}
                                    className={` resizer ${direction}`}
                                    onMouseDown={(e) =>
                                        this.state.isDesktop &&
                                        this.mouseDown(e, direction)
                                    }
                                    style={style}
                                // onMouseUp={(e) =>
                                //     this.mouseup(e, direction)
                                // }
                                ></div>
                            );
                        })}
                    </div>

                </Draggable>
                {/* ) : ''} */}
            </Fragment>
        );
    }
}



const mapStateToProps = (state) => ({
    settings: state.settings,
    user: state.user,
    resource: state.resource,
    notif: state.notif,
    inbox: state.inbox,
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Window);